import { useActiveAgenticLogicView } from "../surface/useActiveAgenticLogicView";
import { AtlasContextSuggestionChips } from "./AtlasContextSuggestionChips";
import { AtlasSuggestionChips } from "./AtlasSuggestionChips";
import { resolveAtlasRailSuggestionContext } from "./atlasRailSuggestionContext";

/**
 * The agentic-logic rail's chip row: the store's rule ideas on the embedded
 * creation view, Atlas's context-aware suggestions everywhere else it has a
 * context. The rail lives outside the page tree, so the surface — and with it
 * the namespaced view and tab params — comes from the registry.
 */
export const AtlasRailSuggestions = () => {
  const { surface, view, tab } = useActiveAgenticLogicView();

  return (
    <>
      <AtlasSuggestionChips />
      <AtlasContextSuggestionChips
        context={surface ? resolveAtlasRailSuggestionContext(view, tab) : null}
      />
    </>
  );
};
